import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import styled from 'styled-components';
import backgroundImage from '../../assets/backgroundImageHome.png';

let statesList = [
 //  'Andhra Pradesh',
 //  'Arunachal Pradesh',
 //  'Assam',
 //  'Bihar',
 //  'Chhattisgarh',
 //  'Goa',
 //  'Gujarat',
 //  'Haryana',
 //  'Himachal Pradesh',
 //  'Jammu and Kashmir',
 //  'Jharkhand',
 //  'Karnataka',
 //  'Kerala',
 //  'Madhya Pradesh',
 //  'Maharashtra',
 //  'Manipur',
 //  'Meghalaya',
 //  'Mizoram',
 //  'Nagaland',
 //  'Odisha',
 //  'Punjab',
 //  'Rajasthan',
 //  'Sikkim',
 //  'Tamil Nadu',
 //  'Telangana',
 //  'Tripura',
 //  'Uttarakhand',
 //  'Uttar Pradesh',
 //  'West Bengal',
 //  'Andaman and Nicobar Islands',
 //  'Chandigarh',
 //  'Dadra and Nagar Haveli',
 //  'Daman and Diu',
 //  'Delhi',
 //  'Lakshadweep',
 //  'Puducherry',
];

const panIndiaDataUrl = 'https://zigma-app.herokuapp.com/users/dashboard';
const stateDataUrl = 'https://zigma-app.herokuapp.com/users/state-data';
const Data = ['-', '-', '-', '-', '-', '-'];
const StateData = {};

const numberBeautifier = (numberToBeBeautified) => {
 const temp = numberToBeBeautified.toString();
 if (temp.length <= 3) return temp + '+';
 else if (temp.length === 4)
  return temp.slice(0, 1) + '.' + temp.slice(1, 3) + 'K+';
 else if (temp.length === 5) return temp.slice(0, 2) + 'K+';
 else if (temp.length === 6)
  return temp.slice(0, 1) + '.' + temp.slice(1, 3) + 'L+';
 else if (temp.length === 7) return temp.slice(0, 2) + 'L+';
 else if (temp.length === 8)
  return temp.slice(0, 1) + '.' + temp.slice(1, 3) + 'C+';
 else if (temp.length === 9) return temp.slice(0, 2) + 'C+';
};
export default function ThirdSection() {
 const [isPanIndia, setPanIndia] = React.useState(true);
 const [state, setState] = useState('Tamil Nadu');
 const [isLoading, setLoading] = useState(true);

 useEffect(() => {
  const getPanIndiaData = () => {
   return new Promise(async (resolve, reject) => {
    try {
     const res = await fetch(panIndiaDataUrl);
     const data = await res.json();
     if (data.processed) Data[0] = numberBeautifier(Math.ceil(data.processed));
     if (data.RDF) Data[1] = numberBeautifier(Math.ceil(data.RDF));
     if (data.MOU) Data[2] = numberBeautifier(Math.ceil(data.MOU));
     if (data.state) Data[3] = numberBeautifier(Math.ceil(data.state));
     if (data['co2_saved'])
      Data[4] = numberBeautifier(Math.ceil(data['co2_saved']));
     if (data['methane_saved'])
      Data[5] = numberBeautifier(Math.ceil(data['methane_saved']));
     resolve('Fetched Successfully');
    } catch (error) {
     console.log(error);
     reject('Network error');
    }
   });
  };

  const getStateData = () => {
   return new Promise(async (resolve, reject) => {
    try {
     statesList = [];
     const res = await fetch(stateDataUrl);
     const data = await res.json();
     data.data.forEach((obj) => {
      statesList.push(obj._id);
      StateData[obj._id] = [numberBeautifier(Math.ceil(obj.achived)), numberBeautifier(Math.ceil(obj["rf_recover"])), numberBeautifier(Math.ceil(obj["co2_saved"]))];
     });
     statesList = statesList.filter(
      (item, index) => statesList.indexOf(item) === index,
     );
     resolve('Fecthed Successfully');
    } catch (error) {
     console.log(error);
     reject('Network error');
    }
   });
  };

  const temp = [];
  temp.push(getPanIndiaData());
  temp.push(getStateData());
  Promise.all(temp).then(() => {
   setState(statesList[0]);
   setLoading(false);
  });
 }, []);

 const handleChange = (event) => {
  setState(event.target.value);
 };
 return (
  <Container>
   <div className='bg'>
    <img src={backgroundImage} alt='background wallpaper' />
   </div>

   <Wrapper>
    {isLoading ? (
     <Box sx={{ display: 'flex' }}>
      <CircularProgress />
     </Box>
    ) : (
     <>
      <Selectdiv visibility={!isPanIndia ? 'visible' : 'hidden'}>
       <FormControl
        sx={{
         m: 1,
         minWidth: 100,
         background: '#FFF',
         color: '##645E58',
         borderRadius: '1rem',
         fontSize: '1.5rem',
         outline: 'none',
         border: 'none',
        }}
       >
        <Select
         labelId='demo-simple-select-autowidth-label'
         id='demo-simple-select-autowidth'
         value={state}
         onChange={handleChange}
         autoWidth
        >
         {statesList.map((state) => (
          <MenuItem value={state}>{state}</MenuItem>
         ))}
        </Select>
       </FormControl>
      </Selectdiv>
      {isPanIndia ? (
       <Statsdiv>
        <Stats>
         <p>{Data[0]}</p>
         <p>tonsMSW possessed</p>
        </Stats>
        <Stats>
         <p>{Data[1]}</p>
         <p>tons of RDF recovered from MSW</p>
        </Stats>
        <Stats>
         <p>{Data[2]}</p>
         <p>MOUs signed with PWPF</p>
        </Stats>
        <Stats>
         <p>{Data[3]}</p>
         <p>State Operated</p>
        </Stats>
        <Stats>
         <p>{Data[4]}</p>
         <p>tons CO2 saved by using RDF as AFR</p>
        </Stats>
        <Stats>
         <p>{Data[5]}</p>
         <p>tons Methane saved by processing MSW</p>
        </Stats>
       </Statsdiv>
      ) : (
       <>
        <Statsdiv>
         <Stats>
          <p>{StateData[state] ? StateData[state][0] : '-'}</p>
          <p>tons of MSW processed</p>
         </Stats>
         <Stats>
          <p>{StateData[state] ? StateData[state][1] : '-'}</p>
          <p>tons of RF recovere from MSW</p>
         </Stats>
         <Stats>
          <p>{StateData[state] ? StateData[state][2] : '-'}</p>
          <p>tons CO2 saved by using RDF as AFR</p>
         </Stats>
        </Statsdiv>
       </>
      )}
      <div>
       <Button
        background={isPanIndia ? '#FFFFFF' : 'transparent'}
        color={isPanIndia ? '#645E58' : '#FFFFFF'}
        borderColor={isPanIndia ? '#FFFFFF' : '#FFFFFF'}
        onClick={() => setPanIndia(true)}
       >
        PAN India
       </Button>
       <Button
        background={!isPanIndia ? '#FFFFFF' : 'transparent'}
        color={!isPanIndia ? '#645E58' : '#FFFFFF'}
        borderColor={!isPanIndia ? '#FFFFFF' : '#FFFFFF'}
        onClick={() => setPanIndia(false)}
       >
        Show Statewise
       </Button>
      </div>
     </>
    )}
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 position: relative;
 .bg {
  z-index: -100;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  img {
   opacity: 0.15;
   width: 100%;
   height: 100%;
   object-fit: cover;
  }
 }
`;

const Wrapper = styled.div`
 width: 75%;
 margin: 0 auto;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 padding-top: 12rem;
 padding-bottom: 4rem;
 z-index: 2;
 > div:last-child {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 2rem;
  margin: 0 auto;
  padding: 2rem 0;
 }
 @media screen and (max-width: 600px) {
  padding-top: 4rem;
 }
`;

const Statsdiv = styled.div`
 width: 100%;
 display: flex;
 flex-wrap: wrap;
 height: 10rem;
 > div {
  border-right: 1px #e0e0e0 solid;
 }
 > div:last-child {
  border-right: none;
 }
 @media screen and (max-width: 600px) {
  height: auto;
  gap: 4rem 1rem;
 }
`;

const Stats = styled.div`
 flex: 1;
 padding: 0 1rem;
 height: 100%;
 display: flex;
 flex-direction: column;
 gap: 2rem;
 justify-content: center;
 align-items: center;
 > p:first-child {
  font-size: 4rem;
  color: #90d62b;
  text-align: center;
  line-height: 2rem;
  font-weight: 700;
 }
 > p:nth-child(2) {
  color: #dedede;
  font-size: 1.2rem;
  line-height: 1rem;
  font-family: 400;
 }
`;

const Button = styled.div`
 background: ${(props) => props.background};
 border-radius: 1rem;
 color: ${(props) => props.color};
 border: 2px solid ${(props) => props.borderColor};
 font-size: 1.5rem;
 width: fit-content;
 padding: 0.5rem 2rem;
 width: 16rem;
 margin-left: auto;
 font-weight: 600;
 cursor: pointer;
`;

const Selectdiv = styled.div`
 visibility: ${(props) => props.visibility};
 div {
  font-size: 1.5rem;
  font-weight: 600;
 }
 svg {
  font-size: 1.5rem;
  background-color: #98d82f;
  color: #fff;
  border-radius: 0.25rem;
 }
 input,
 fieldset,
 select,
 div {
  border: none;
  outline: none;
 }
`;
